import { NgClass } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CustomerPaymentMethodData } from '../../../content/interfaces/payment/customer-payment-method-data';
import { I18nService } from '../../../core/services/i18n.service';
import { SpsCustomIconComponent } from '../sps-custom-icon/sps-custom-icon.component';

@Component({
  selector: 'sps-payment-method-list-item',
  imports: [
    SpsCustomIconComponent,
    NgClass,
  ],
  templateUrl: './sps-payment-method-list-item.component.html',
})
export class SpsPaymentMethodListItemComponent {

  @Input() paymentListItem: CustomerPaymentMethodData;
  @Output() itemClicked = new EventEmitter<CustomerPaymentMethodData>();

  i18n = inject(I18nService);

 }
